<template>
  <div class="content pr-2">
    <div
      v-if="!show"
      class="spinner-loader"
    >
      <sync-loader />
      <p>Loading ...</p>
    </div>
    <div v-if="show">
      <div>
        <news-list
          v-if="page === 'news-list'"
          :news="news"
          @selectNews="selectNews"
        />
        <whole-news
          v-if="page === 'whole-news'"
          :news="selectedNews"
          @backToList="backToList"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import NewsList from './NewsList.vue'
  import WholeNews from './WholeNews.vue'
  import axios from 'axios'

  export default {
    name: 'News',
    metaInfo: {
      title: 'AHL Poker :: News'
    },
    components: {
      NewsList,
      WholeNews
    },
    props: ['user', 'token'],
    data() {
      return {
        page: 'news-list',
        show: false,
        news: [],
        selectedNews: {}
      }
    },
    created() {
      this.$axios({
        method: 'POST',
        url: 'general',
        data: {
          token: this.token || ''
        }
      })
        .then((res) => {
          this.show = true
          this.news = res.data.news
        })
        .catch((error) => {
          this.$emit('message', {error: true, showDialog: true, message: error.response.data.message})
        })
    },
    methods: {
      selectNews(news) {
        this.selectedNews = news
        this.page = 'whole-news'
      },
      backToList() {
        this.selectedNews = {}
        this.page = 'news-list'
      }
    }
  }
</script>
